(function () {
  'use strict';

  var API_NAME = 'EssntlGenderSwitcher';
  var SWITCHER_SELECTOR = '[data-essntl-gender-switcher]';

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function parseJson(element) {
    if (!element) return null;
    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      console.error('[ESSNTL gender switcher] Invalid paired-product data.', error);
      return null;
    }
  }

  function selectedSize(switcher) {
    var productRoot = switcher.closest('[data-lg-product-root]');
    if (!productRoot) return '';

    var activeSize = productRoot.querySelector('.essntl-size-btn.is-active[data-size]');
    if (activeSize) return activeSize.getAttribute('data-size') || '';

    var variantInput = productRoot.querySelector('#essntl-variant-id');
    var variantsElement = productRoot.querySelector('[data-lg-variants-json]');
    var currentVariants = parseJson(variantsElement);
    var sizeIndex = parseInt(productRoot.getAttribute('data-lg-size-index'), 10);

    if (!variantInput || !Array.isArray(currentVariants) || sizeIndex < 0) return '';

    var selectedId = String(variantInput.value || '');
    var selectedVariant = currentVariants.find(function (variant) {
      return String(variant.id) === selectedId;
    });

    if (!selectedVariant || !Array.isArray(selectedVariant.options)) return '';
    return selectedVariant.options[sizeIndex] || '';
  }

  function destinationUrl(target, size) {
    if (!target || !target.url) return '';

    var url = new URL(target.url, window.location.origin);
    url.searchParams.delete('variant');

    var sizeIndex = Number(target.sizeIndex);
    if (!size || sizeIndex < 0 || !Array.isArray(target.variants)) return url.toString();

    var normalizedSize = normalize(size);
    var matchingVariant = target.variants.find(function (variant) {
      if (!variant || variant.available !== true || !Array.isArray(variant.options)) return false;
      return normalize(variant.options[sizeIndex]) === normalizedSize;
    });

    if (matchingVariant && matchingVariant.id) {
      url.searchParams.set('variant', matchingVariant.id);
    }

    return url.toString();
  }

  function initSwitcher(switcher) {
    if (!switcher || switcher.getAttribute('data-essntl-gender-initialized') === 'true') return;

    var toggle = switcher.querySelector('[data-essntl-gender-toggle]');
    var target = parseJson(switcher.querySelector('[data-essntl-gender-target]'));
    var status = switcher.querySelector('[data-essntl-gender-status]');

    if (!toggle || !target || !target.url) {
      switcher.hidden = true;
      return;
    }

    switcher.setAttribute('data-essntl-gender-initialized', 'true');

    toggle.addEventListener('click', function () {
      if (toggle.disabled) return;

      var destination = destinationUrl(target, selectedSize(switcher));
      if (!destination) return;

      toggle.disabled = true;
      toggle.setAttribute('aria-busy', 'true');
      switcher.classList.add('is-loading');
      if (status) status.textContent = 'Opening the matching product.';

      window.location.assign(destination);
    });
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll(SWITCHER_SELECTOR), initSwitcher);
  }

  if (window[API_NAME]) {
    window[API_NAME].initAll(document);
    return;
  }

  window[API_NAME] = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
